import axios from 'axios'
import config from '../../config/index.js'

// 创建axios实例
const service = axios.create({
  baseURL: config.baseURL || '', // 使用config配置文件中的baseURL
  timeout: 10000 // 请求超时时间
})

// 请求拦截器
service.interceptors.request.use(
  requestConfig => {
    // 在发送请求之前做些什么
    // 可以在这里添加token等
    return requestConfig
  },
  error => {
    // 对请求错误做些什么
    console.error('请求错误:', error)
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    // 对响应数据做点什么
    const res = response.data
    // 根据后端返回的数据结构处理
    // code为0表示成功，非0表示失败
    if (res.code !== undefined && res.code !== 0 && res.code !== 200) {
      // 如果后端返回了错误码
      console.error('接口返回错误:', res.msg || res.message)
      return Promise.reject(new Error(res.msg || res.message || '请求失败'))
    }
    return res
  },
  error => {
    // 对响应错误做点什么
    console.error('响应错误:', error)
    return Promise.reject(error)
  }
)

export default service

